import { v4 as uuid } from 'uuid'
import { NotificationStatusEnum } from './NotificationStatusEnum'
import { NotificationTypeEnum } from './NotificationTypeEnum'
import { User } from '..'
import { NotificationClassificationEnum } from './NotificationClassificationEnum'

export interface INotification {
  id: string
  type: NotificationTypeEnum
  classification: NotificationClassificationEnum
  status: NotificationStatusEnum
  to: User
  data: object
  error?: string
  refId?: string
  sendData?: object
  linkReplacement?: { name: string, template: string }[]
}

export class Notification implements INotification {
  public id: string = uuid()
  public status: NotificationStatusEnum = NotificationStatusEnum.PENDING
  public data: object = {}
  public error?: string
  public refId?: string
  public sendData?: object
  public linkReplacement?: { name: string, template: string }[]

  constructor(public to: User, public type: NotificationTypeEnum, public classification: NotificationClassificationEnum) {}

  public get subject() {
    return ''
  }

  public get body() {
    return ''
  }
}
